<template>
  <div class="items-center justify-center w-full text-center" id="imageUpload">
    <div class="p-12 bg-gray-100 border border-gray-300"
      @dragover="dragover" @dragleave="dragleave" @drop="drop">
      <input type="file" multiple name="fields[assetsFieldHandle][]" id="assetsFieldHandle"
        class="w-px h-px opacity-0 overflow-hidden absolute" @change="onChange"
          ref="file" accept=".jpg,.jpeg,.png" />

      <label for="assetsFieldHandle" class="block cursor-pointer">
        <div>
          <span class="underline">click aqui</span>, ou arraste arquivos,
          para inserir mais fotos
        </div>
      </label>
    </div>

    <div class="boxImageUpload">
      <div
        style="position: relative;"
        v-for="(image, index) in this.images"
        :key="index"
      >
        <div class="divImagesPropertyImageUpload">
          <img class="imagePropertyImageUpload" :src="image"/>
          <a href="javascript:void(0)" class="close_btn" @click="remove(index)">&times;</a>
        </div>
      </div>
    </div>

    <div style="width: 160px; height: 40px; margin: auto;
      margin-top: 16px; margin-bottom: 16px;">
    <button class="btnSalvar" style="width: 160px;"
      @click="uploadImages">
      Carregar Imagens
    </button>
    </div>
  </div>
</template>

<script>
export default {
  delimiters: ['${', '}'], // Avoid Twig conflicts
  data() {
    return {
      images: [],
      files: [],
    };
  },
  props: [
    'property_id',
    'cleanFiles',
  ],
  watch: {
    property_id: {
      immediate: true,
      deep: true,
      handler() {
        this.images = [];
        this.files = [];
      },
    },
    cleanFiles: {
      immediate: true,
      deep: true,
      handler() {
        this.images = [];
        this.files = [];
      },
    },
  },
  methods: {
    onChange() {
      Array.from(this.$refs.file.files).map((image) => {
        const imgElement = document.createElement('IMG');
        imgElement.src = window.URL.createObjectURL(image);
        const canvasElement = document.createElement('CANVAS');

        const ctx = canvasElement.getContext('2d');

        imgElement.onload = () => {
          let widthNew;
          let heightNew;
          if (imgElement.width > imgElement.height) {
            if (imgElement.width > 1080) {
              heightNew = imgElement.height * (1080 / imgElement.width);
              widthNew = 1080;
            } else {
              heightNew = imgElement.height;
              widthNew = imgElement.width;
            }
          } else if (imgElement.height > 1080) {
            widthNew = imgElement.width * (1080 / imgElement.height);
            heightNew = 1080;
          } else {
            heightNew = imgElement.height;
            widthNew = imgElement.width;
          }
          canvasElement.width = widthNew;
          canvasElement.height = heightNew;
          ctx.drawImage(imgElement, 0, 0, imgElement.width, imgElement.height, 0, 0,
            widthNew, heightNew);

          canvasElement.toBlob((blob) => {
            const newImg = document.createElement('img');

            newImg.src = URL.createObjectURL(blob);
            this.files.push(blob);
            this.images.push(newImg.src);
          }, 'image/jpeg', 0.85);
        };
        imgElement.src = window.URL.createObjectURL(image);
        return true;
      });
    },
    remove(i) {
      this.images.splice(i, 1);
      this.files.splice(i, 1);
    },
    uploadImages() {
      if (this.files.length > 0) {
        this.$emit('uploadimages', this.files);
      }
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains('bg-green-300')) {
        event.currentTarget.classList.remove('bg-gray-100');
        event.currentTarget.classList.add('bg-green-300');
      }
    },
    dragleave(event) {
      // Clean up
      event.currentTarget.classList.add('bg-gray-100');
      event.currentTarget.classList.remove('bg-green-300');
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add('bg-gray-100');
      event.currentTarget.classList.remove('bg-green-300');
    },
    setImage: (image) => {
      this.image = image;
    },
  },
};
</script>

<style>
.items-center{
  margin:auto;
  margin-bottom: 16px;
}
.close_btn {
  position: absolute;
  top: 3px;
  right: 2px;
  font-size: 30px;
}
.justify-center{justify-content:center}
.w-full{width:95%}
.text-center{text-align:center}
.p-12{padding:3rem}
.bg-gray-100{background-color:#f7fafc}
.border{border-width:1px}
.border-gray-300{border-color:#e2e8f0}
.w-px{width:1px}
.h-px{height:1px}
.opacity-0{opacity:0}
.overflow-hidden{overflow:hidden}
.absolute{position:absolute}
.block{display:block}
.cursor-pointer{cursor:pointer}
.underline{text-decoration:underline}
.mt-4{margin-top:1rem}
.text-sm{font-size:.875rem}
.p-1{padding:.25rem}

.divImagesProperty {
  height: 150px;
  width: 150px;
}
.boxImageUpload {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;
  position: relative;
}
.imagePropertyImageUpload {
  position: relative;
  border-radius: 3px;
  margin: 2px;
  max-width: 100%;
  max-height: 100%;
}
.divImagesPropertyImageUpload {
  height: 150px;
  width: 150px;
}
</style>
